import { React, useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useTranslation } from "../../utils/hooks/translateHook.js";
import './Courses.css'; 
import HTML from "../../images/courses/arrow.png";
import PYTHON from "../../images/courses/Rocket.png";
import JAVASCRIPT from "../../images/courses/Pink Computer.png";
import SEO from "../../images/courses/Violet computer.png";
import SMM from "../../images/courses/media.png";
import FUNDAMENTALS from "../../images/courses/Trading.png";
import HeroImg from "../../images/Yellow Guy.png";
import RocketIcon from "../../images/icons/roketIcon.svg";
import Highskils from "../../images/icons/highskilsIcon.svg";
import DiamondIcon from "../../images/icons/diamondIcon.svg";
import Crown from "../../images/icons/CrownPurpleIcon.svg"

function Courses () {
  const t = useTranslation();
  const [activeFilter, setActiveFilter] = useState("all");
  const {hash} = useLocation();
  const containerRef = useRef(null);
  const [activeCard, setActiveCard] = useState(null);   // hover
  const [lockedCard, setLockedCard] = useState(null);   // click
  const handleMouseEnter = (slug) => { if (lockedCard) return; setActiveCard(slug);};
  const handleMouseLeave = () => { if (lockedCard) return; setActiveCard(null);};

  const handleCardClick = (slug) => {
    setLockedCard(prev => {
      const newLocked = prev === slug ? null : slug;
      setActiveCard(newLocked);
      return newLocked;
    });
  };
   
  useEffect(() => {
    if (!hash) return;
    const el = document.getElementById(hash.slice(1));
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start"});
    }     
  }, [hash]);

  const courses = [
    {slug: "html", title: t("courseHeader_1"), description: t("courseDescription_p1"), img: HTML, category: "web"},
    {slug: "python", title: t("courseHeader_2"), description: t("courseDescription_2p1"), img: PYTHON, category: "web"},
    {slug: "javascript", title: t("courseHeader_3"), description: t("courseDescription_3p1"), img: JAVASCRIPT, category: "web"},
    {slug: "seo", title: t("courseHeader_4"), description: t("courseDescription_4p1"), img: SEO, category: "marketing"},
    {slug: "smm", title: t("courseHeader_5"), description: t("courseDescription_5p1"), img: SMM, category: "marketing"},
    { slug: "fundamentals", title: t("courseHeader_6"), description: t("courseDescription_6p1"), img: FUNDAMENTALS, category: "finance"}
  ];

  const filteredCourses = activeFilter === "all" ? courses : courses.filter(c => c.category === activeFilter);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setActiveCard(null);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => { 
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target))
        { setActiveCard(null);}
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  },[]);

  return (
    <div name="courses-main" className="container" >
      <div className="courses-hero">
        <div className="hero-image">
            <img src={HeroImg} alt="Hero" />
        </div>
        <div className="hero-content">
          <h2 className="hero-title">
            <span>{t("course.hero.line1")}</span>
            <span className="line2-c">{t("course.hero.line2")}</span>
          </h2>
          <div className="hero-tags">
            <div className="hero-tag">
              <img src={RocketIcon} alt="icon" />
              {t("course.hero.tag1")}
            </div>
            <div className="hero-tag">
                <img src={Highskils} alt="icon" />
                {t("course.hero.tag2")}
            </div>
            <div className="hero-tag">
               <img src={DiamondIcon} alt="icon" />
                {t("course.hero.tag3")}
            </div>
          </div>
        </div>
      </div>
    
     <h1 className="courses-title"> {t("coursesPageHeader")}</h1>
      <div className="filters">
        <button className={activeFilter === "all" ? "active" : ""} onClick={() => setActiveFilter("all")}>ALL</button>
        <button className={activeFilter === "web" ? "active" : ""} onClick={() => setActiveFilter("web")}>WEB</button>
        <button className={activeFilter === "marketing" ? "active" : ""} onClick={() => setActiveFilter("marketing")}>MARKETING</button>
        <button className={activeFilter === "finance" ? "active" : ""} onClick={() => setActiveFilter("finance")}>FINANCE</button>
      </div>

      <div className="courses-grid">
        {filteredCourses.map(course => (
          <div key={course.slug}
              className={`course-card-gest ${activeCard === course.slug ? "open" : ""}`}
              onMouseEnter={() => handleMouseEnter(course.slug)}
              onMouseLeave={handleMouseLeave}
              onClick={() => handleCardClick(course.slug)}

          >
            <h3>{course.title}</h3>
            <img src={course.img} alt={course.title}/> 
             <div className="course-text-box">
                <div className="course-description">
                  {course.description}
                </div>

                <NavLink to="/upgrade" className="upgrade-inside">
                  <span className="upgrade-text">{t("upgrade").toUpperCase()}</span>

                  <div className="crown-wrapper">
                    <img src={Crown} className="crown-icon" alt="crown" />
                  </div>
                </NavLink>
             </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Courses;